// Prefix a public-folder asset path with Vite's BASE_URL.
// Vite rewrites paths in index.html automatically, but paths used inside JS
// modules (e.g. dynamic image src in data.ts) need this helper so they resolve
// correctly when the site is served from a subpath like /aipq-vert-slice/.
export function asset(path: string): string {
  const base = import.meta.env.BASE_URL || "/";
  const trimmed = path.replace(/^\/+/, "");
  return base.endsWith("/") ? `${base}${trimmed}` : `${base}/${trimmed}`;
}
